import { X } from "lucide-react";

const CookieConsent = ({ onAccept }) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-gray-900 text-white rounded-lg shadow-2xl max-w-md mx-4 p-6 relative">
        <button
          onClick={onAccept}
          className="absolute top-3 right-3 p-1 hover:bg-gray-800 rounded transition-colors"
          aria-label="Close"
        >
          <X className="w-5 h-5" />
        </button>
        
        <div className="space-y-4">
          <p className="text-sm leading-relaxed">
            This website uses cookies, affiliate links and third party services that may track your activity.
          </p>
          
          <p className="text-sm">
            Find out more{" "}
            <a
              href="/terms"
              className="text-blue-400 hover:text-blue-300 underline"
            >
              here
            </a>
          </p>
          
          <button
            onClick={onAccept}
            className="w-full bg-green-600 hover:bg-green-700 text-white font-medium py-2 px-4 rounded transition-colors"
          >
            I agree
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
